(function () {
  var SECTION_SEL = '.legal-page';
  var CATEGORY_SEL = '.legal-page__category';
  var NAV_LINK_SEL = '.legal-page__nav-link';
  var CHIP_SEL = '.legal-page__mobile-chip';
  var ACTIVE_CLASS = 'is-active';

  var section = document.querySelector(SECTION_SEL);
  if (!section) return;

  var categories = section.querySelectorAll(CATEGORY_SEL);
  var navLinks = section.querySelectorAll(NAV_LINK_SEL);
  var chips = section.querySelectorAll(CHIP_SEL);

  if (!categories.length) return;

  function setActive(id) {
    navLinks.forEach(function (link) {
      link.classList.toggle(ACTIVE_CLASS, link.getAttribute('href') === '#' + id);
    });
    chips.forEach(function (chip) {
      chip.classList.toggle(ACTIVE_CLASS, chip.getAttribute('href') === '#' + id);
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        setActive(entry.target.id);
      }
    });
  }, {
    rootMargin: '-15% 0px -65% 0px',
    threshold: 0
  });

  categories.forEach(function (cat) { observer.observe(cat); });
})();
